import React from "react";
import { dsnCN } from "../../hooks/helper";

function ContentFooter({ className, ...restProps }) {
  return (
    <div className={dsnCN("col-menu", className)} {...restProps}>
      <p>
        <strong>E</strong> <span>:</span>{" "}
        <a href="mailto:whisper@mystirien.com"> whisper@mystirien.com</a>
      </p>
      <p>
        <strong>G</strong> <span>:</span>{" "}
        <a href="mailto:mystirien@gmail.com"> mystirien@gmail.com</a>
      </p>
    </div>
  );
}

export default ContentFooter;
